module.exports = __webpack_public_path__ + "img/united-states.50961359.png";